// extracted by mini-css-extract-plugin
export default {"wrapper":"authSuccess-module__wrapper__7cVpU"};